import { useUserStore } from '@/stores/user'
import type { Nullable, PaymentMethod } from '@/types'
import { computed, ref, watch } from 'vue'

export function useOneClickPayment(options?: {
  clearPaymentErrors?: () => void
}) {
  const userStore = useUserStore()

  const isOneClickPayOpen = ref(false)

  const oneClickPay = computed<Nullable<PaymentMethod>>(
    () =>
      Object.values(userStore.user?.payment_methods ?? {}).find(
        (method) => method.one_click_enabled
      ) ?? null
  )

  const paymentFormType = computed(() =>
    isOneClickPayOpen.value ? 'one-click-pay' : 'add-new-card'
  )

  watch(isOneClickPayOpen, (newValue) => {
    if (!newValue) {
      setTimeout(() => options?.clearPaymentErrors?.(), 500)
    }
  })

  function reset() {
    isOneClickPayOpen.value = false
  }

  return {
    isOneClickPayOpen,
    oneClickPay,
    paymentFormType,
    reset,
  }
}
